import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import Button from 'components/common/Button/Button'
import Icon from 'components/common/Icon/Icon'
import ArrowRightBrightRed from 'components/common/Icon/assets/Arrow-right-bright-red.svg'
import ArrowRightWhite from 'components/common/Icon/assets/Arrow-right-white.svg'

const ShopBySize = ({ onClick, appointmentTitle, isHovering, setIsHovering }) =>
  <>
    <Title>
      Don’t have your tire size handy?
    </Title>
    <Description>
      Get in-store assistance finding the best tires, services, and deals for your vehicle and budget.
    </Description>
    <HelperWrapper
      onMouseEnter={ () => setIsHovering(true) }
      onMouseLeave={ () => setIsHovering(false) }
      onClick={ onClick }>
      <CustomIcon asset={ `${isHovering ? 'book-appointment-white' : 'book-appointment-red'}` } width={ 35 } />
      <AppointmentButton
        data-at-quick-appointment-button
        important
        follow_alternative>
        { appointmentTitle }
      </AppointmentButton>
    </HelperWrapper>
  </>

export default ShopBySize

ShopBySize.propTypes = {
  appointmentTitle: PropTypes.string,
  isHovering: PropTypes.bool,
  onClick: PropTypes.func,
  setIsHovering: PropTypes.func
}

const Title = styled.div`
  ${Mixin.font.GothamBold(16)};
  margin-bottom: 20px;
`

const Description = styled.div`
  ${Mixin.font.GothamBook(16)};
  color: ${Theme.colors.black_new};
  margin-bottom: 35px;
`

const AppointmentButton = styled(Button)`
  padding: 14px 30px 13px 90px;
  ${Mixin.font.GothamBold(16)};
  color: ${Theme.colors.bright_red_new};
  cursor: pointer;
  width: 358px;
  border-color: ${Theme.colors.bright_red_new};

  ::after {
    content: url(${ArrowRightBrightRed});
  }

  &:hover {
    border-color: ${Theme.colors.crimson};
    color: ${Theme.colors.white};
    background-color: ${Theme.colors.crimson};

    ::after {
      content: url(${ArrowRightWhite});
    }
  }

  @media (max-width: 500px) {
    width: 100%;
  }

  @media (max-width: 400px) {
    font-size: 16px;
    padding: 10px 30px 11px 75px;
  }
`

const CustomIcon = styled(Icon)`
  position: absolute;
  cursor: pointer;
  top: 50%;
  left: 30px;
  z-index: 1;
  transform: translateY(-50%);
`

const HelperWrapper = styled.div`
  position: relative;
  display: inline-block;

  @media (max-width: 500px) {
    width: 100%;
  }
`
